import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';
import { RequiredValidator } from '../validators/Required';

const properties: PropertiesInterface = {
  customGeneratedId: {
    type: 'UUID',
    friendlyName: 'UniqueAttachmentSectionId',
    validators: [],
  },
  attachments: {
    type: 'JSON',
    friendlyName: 'Attachments',
    isArray: true,
    // "Must have at least one attachment" is enforced by the outer field's
    // Required validator (see addRequiredValidator below) so that fields with
    // Required: false can be submitted without uploading any files. Keeping a
    // hardcoded ArrayMin here would force every Attachment field to be
    // effectively required.
    validators: [
      {
        name: 'ArrayMax',
        value: 25,
      },
    ],
  },
};
export class AttachmentType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Attachment';

  friendlyName = 'Attachment';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  superUserOnly = false;

  properties = properties;

  get example() {
    return {
      customGeneratedId: '123',
      attachments: [],
    };
  }

  get default(): any {
    return {
      customGeneratedId: '',
      attachments: [],
    };
  }

  formatter = (value: any): string => {
    const attachments = value?.attachments;

    if (!Array.isArray(attachments) || attachments.length === 0) {
      return '';
    }
    
    return attachments
      .map((a: any) => a?.file?.name || a?.name || '')
      .filter(Boolean)
      .join(', ');
  };

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  addRequiredValidator(validator: RequiredValidator): any {
    if (validator.config?.value) {
      this._schema = this.schema.test(
        'Required',
        `${this.getDisplayName()} is a required field.`,
        value => Boolean(value?.attachments?.length)
      );
    } else {
      this._schema = this.schema.notRequired();
    }
  }
}
export const definition = new AttachmentType();

Types.addBaseType(definition);
